import {
  getMasterData,
  IMasterDataResponse,
  IWarehouse,
  IWorkcenter,
  ISupplier,
  ITrackingPoint,
} from '@/apis/masterDataAPI'
import { convertArrayToRecord } from '@/utils/helpers'
import { CLEAR_MASTER_DATA, FETCH_MASTER_DATA, SET_MASTER_DATA_LOADING } from './actions'

type TMasterDataState = {
  warehouses: Record<string, IWarehouse>
  workcenters: Record<string, IWorkcenter>
  suppliers: Record<string, ISupplier>
  trackingPoints: Record<string, ITrackingPoint>
  isLoaded: boolean
  isLoading: boolean
}

export default {
  state: {
    warehouses: {},
    workcenters: {},
    suppliers: {},
    trackingPoints: {},
    isLoaded: false,
    isLoading: false,
  },
  mutations: {
    [FETCH_MASTER_DATA]: (state: TMasterDataState, payload: IMasterDataResponse) => {
      state.warehouses = convertArrayToRecord(payload.warehouses || [])
      state.workcenters = convertArrayToRecord(payload.workcenters || [])
      state.suppliers = convertArrayToRecord(payload.suppliers || [])
      state.trackingPoints = convertArrayToRecord(payload.trackingPoints || [])
      state.isLoaded = true
      state.isLoading = false
    },
    [CLEAR_MASTER_DATA]: (state: TMasterDataState) => {
      state.warehouses = {}
      state.workcenters = {}
      state.suppliers = {}
      state.trackingPoints = {}
      state.isLoaded = false
      state.isLoading = false
    },
    [SET_MASTER_DATA_LOADING]: (state: TMasterDataState, loading: boolean) => {
      state.isLoading = loading
    },
  },
  actions: {
    [FETCH_MASTER_DATA]: async (
      {
        commit,
        state,
      }: {
        commit: Function
        state: TMasterDataState
      },
      payload?: { force: boolean }
    ) => {
      try {
        // Only fetch if not already loaded or if force is true
        if (!state.isLoaded || payload?.force) {
          commit(SET_MASTER_DATA_LOADING, true)
          const response = await getMasterData()
          if (!response) return
          commit(FETCH_MASTER_DATA, response)
        }
      } catch (err) {
        commit(SET_MASTER_DATA_LOADING, false)
        throw err
      }
    },
    [CLEAR_MASTER_DATA]: ({ commit }: { commit: Function }) => {
      commit(CLEAR_MASTER_DATA)
    },
  },
  getters: {
    getMasterDataWarehouses: (state: TMasterDataState) => state.warehouses,
    getMasterDataWorkcenters: (state: TMasterDataState) => state.workcenters,
    getMasterDataSuppliers: (state: TMasterDataState) => state.suppliers,
    getMasterDataTrackingPoints: (state: TMasterDataState) => state.trackingPoints,
    isMasterDataLoading: (state: TMasterDataState) => state.isLoading,
    isMasterDataLoaded: (state: TMasterDataState) => state.isLoaded,
  },
}
